import { render, staticRenderFns } from "./customEdit.vue?vue&type=template&id=10757b8e&scoped=true&"
import script from "./customEdit.vue?vue&type=script&lang=tsx&"
export * from "./customEdit.vue?vue&type=script&lang=tsx&"
import style0 from "./customEdit.vue?vue&type=style&index=0&id=10757b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10757b8e",
  null
  
)

export default component.exports